import React from 'react';

const StockAppStory = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>💼 From Hustler to Millionaire: My 8-Year Investing Journey</h1>

      <p style={styles.intro}>
        At 22, I had $150,000 from years of hustling: freelance gigs, reselling sneakers, and working weekends. No degree. No inheritance. Just grit.
        At 30, I’ve turned that into over <strong>$1.15 million</strong> — not through luck, but smart moves, patience, and taking some calculated risks.
      </p>

      {sections.map((section, index) => (
        <div key={index} style={styles.card}>
          <h2 style={styles.heading}>{section.heading}</h2>
          {section.paragraphs.map((p, i) => (
            <p key={i} style={styles.paragraph}>{p}</p>
          ))}
          {section.list && (
            <ul style={styles.list}>
              {section.list.map((item, idx) => (
                <li key={idx} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}

      <div style={styles.footer}>
        <h2 style={styles.heading}>📚 8 Lessons From the Hustle</h2>
        <ul style={styles.list}>
          {lessons.map((lesson, index) => (
            <li key={index} style={styles.listItem}><strong>{index + 1}.</strong> {lesson}</li>
          ))}
        </ul>
      </div>

      <p style={styles.outro}>
        I'm still going. My goal now is flexibility: travel, freedom, maybe early retirement. The money matters — but what it lets me do matters more.
      </p>

     
    </div>
  );
};

// 🔹 Section content
const sections = [
  {
    heading: '📅 Year 1: Foundation & First Moves',
    paragraphs: [
      'I deployed $150K carefully:',
    ],
    list: [
      '$70K in ETFs (VTI, SPY)',
      '$20K in dividend growth stocks (AAPL, MSFT)',
      '$30K in cash/bonds',
      '$30K in speculative plays (BTC, ETH, SQ, SHOP)',
    ],
  },
  {
    heading: '📈 Years 2–3: Learning & Earning',
    paragraphs: [
      'I contributed $2K/month from freelance web dev. Built my base around ETFs and reinvested every dividend.',
      'Started using DRIP, learned about P/E ratios, and began journaling every trade. Portfolio hit $230K by 2019.',
    ],
  },
  {
    heading: '🧠 Year 4: Chaos & Conviction',
    paragraphs: [
      'Pandemic crash. Portfolio dropped 35%. I didn’t panic — I bought more.',
      'Added Tesla below $100 (split-adjusted), and started trading basic options like covered calls.',
    ],
  },
  {
    heading: '🚀 Years 5–6: Scaling & Strategy',
    paragraphs: [
      'Big gains from crypto and Tesla. Took profits, shifted to income plays (REITs, SCHD).',
    ],
    list: [
      'Monthly dividends hit $300',
      'Portfolio passed $500K',
      'Started using Roth IRA & HSA yearly',
    ],
  },
  {
    heading: '🏗️ Year 7: Systems Over Hype',
    paragraphs: [
      'Raised contributions to $3,500/month. Stopped chasing hype. Set up auto DCA. Focused on consistency.',
    ],
    list: [
      'Auto-buy VTI, VXUS, SCHD monthly',
      'Started custodial ETF account for nephew',
      'Portfolio closed at $750K',
    ],
  },
  {
    heading: '🏁 Year 8: Hitting 7 Figures',
    paragraphs: [
      'In 2024, I passed $1M. Not from day-trading, but from building. Here’s how it’s split:',
    ],
    list: [
      '35% Broad ETFs (VTI, SCHD)',
      '20% Tech Stocks (NVDA, MSFT, AMZN)',
      '10% International (VXUS)',
      '10% REITs & Dividends (VYM)',
      '10% Crypto (BTC, ETH)',
      '10% Cash equivalents',
      '5% High-conviction new plays + options income',
    ],
  },
];

const lessons = [
  'Your first $100K is the hardest.',
  'Be boring. Boring builds wealth.',
  'Don’t invest all cash — but don’t sit out either.',
  'DRIP works. Dividends compound faster than you think.',
  'Take profits. Don’t hold forever.',
  'Time > timing. Stay invested.',
  'Index ETFs do 80% of the work.',
  'Nobody’s coming to save you — learn to manage your own money.',
];

// 🎨 Styles
const styles = {
  container: {
    maxWidth: '880px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: '"Segoe UI", sans-serif',
    backgroundColor: '#f9fbfc',
    color: '#2c3e50',
    lineHeight: '1.75',
  },
  title: {
    fontSize: '2.2rem',
    fontWeight: 'bold',
    marginBottom: '1.2rem',
    color: '#003366',
  },
  intro: {
    fontSize: '1.1rem',
    marginBottom: '1.8rem',
  },
  heading: {
    fontSize: '1.4rem',
    marginBottom: '0.5rem',
    color: '#0070f3',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '1.5rem',
    marginBottom: '2rem',
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
  },
  paragraph: {
    marginBottom: '1rem',
  },
  list: {
    paddingLeft: '1.4rem',
    marginTop: '1rem',
    marginBottom: '0.5rem',
    listStyleType: 'none' ,
  },
  listItem: {
    marginBottom: '0.6rem',
  },
  footer: {
    backgroundColor: '#eaf4ff',
    borderRadius: '6px',
    padding: '1.5rem',
    marginTop: '2.5rem',
  },
  outro: {
    marginTop: '2rem',
    fontSize: '1rem',
    fontWeight: '500',
  },
  disclaimer: {
    fontSize: '12px',
    color: '#777',
    marginTop: '2rem',
    fontStyle: 'italic',
  },
};

export default StockAppStory;
